import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-31df45d0")

_pushScopeId("data-v-31df45d0")
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("h5", null, "Informações Pessoais", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Nome")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Data de Nascimento")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Gênero")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Masculino")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Feminino")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Outro")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Prefiro não informar")
const _hoisted_11 = /*#__PURE__*/_createVNode("h5", null, "Contato", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Celular")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Celular Alternativo")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("E-mail")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Confirmar ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_with_balance = _resolveComponent("header-with-balance")
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_select_option = _resolveComponent("ion-select-option")
  const _component_ion_select = _resolveComponent("ion-select")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_footer = _resolveComponent("ion-footer")
  const _component_ion_page = _resolveComponent("ion-page")
  const _directive_mask = _resolveDirective("mask")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_header_with_balance, {
            class: "balance-header",
            title: "Editar informações"
          }),
          _createVNode("div", _hoisted_1, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode(_component_ion_skeleton_text, { animated: "" }),
                  _createVNode(_component_ion_skeleton_text, { animated: "" }),
                  _createVNode(_component_ion_skeleton_text, { animated: "" }),
                  _createVNode(_component_ion_skeleton_text, { animated: "" }),
                  _createVNode(_component_ion_skeleton_text, { animated: "" })
                ]))
              : (_openBlock(), _createBlock(_component_ion_grid, { key: 1 }, {
                  default: _withId(() => [
                    _hoisted_3,
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_label, { position: "floating" }, {
                                  default: _withId(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  modelValue: _ctx.name,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
                                  type: "text",
                                  class: "capitalize",
                                  disabled: "",
                                  onClick: $options.alertName
                                }, null, 8, ["modelValue", "onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_label, { position: "floating" }, {
                                  default: _withId(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  modelValue: _ctx.birth,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.birth = $event)),
                                  type: "tel",
                                  autocomplete: "bday"
                                }, null, 8, ["modelValue"]),
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.birth = $event)),
                                  style: {"display":"none"}
                                }, null, 512), [
                                  [_vModelText, _ctx.birth],
                                  [_directive_mask, '##/##/####']
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_label, { position: "floating" }, {
                                  default: _withId(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_select, {
                                  modelValue: _ctx.gender,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.gender = $event)),
                                  "ok-text": "OK",
                                  "cancel-text": "Cancelar"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_select_option, { value: "M" }, {
                                      default: _withId(() => [
                                        _hoisted_7
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_select_option, { value: "F" }, {
                                      default: _withId(() => [
                                        _hoisted_8
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_select_option, { value: "O" }, {
                                      default: _withId(() => [
                                        _hoisted_9
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_select_option, { value: "N" }, {
                                      default: _withId(() => [
                                        _hoisted_10
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_11,
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_label, { position: "floating" }, {
                                  default: _withId(() => [
                                    _hoisted_12
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  modelValue: _ctx.phone,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.phone = $event)),
                                  type: "tel",
                                  autocomplete: "tel-national"
                                }, null, 8, ["modelValue"]),
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.phone = $event)),
                                  style: {"display":"none"}
                                }, null, 512), [
                                  [_vModelText, _ctx.phone],
                                  [_directive_mask, '(##) #####-####']
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_label, { position: "floating" }, {
                                  default: _withId(() => [
                                    _hoisted_13
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  modelValue: _ctx.phoneAlternative,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.phoneAlternative = $event)),
                                  type: "tel",
                                  autocomplete: "tel-national"
                                }, null, 8, ["modelValue"]),
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.phoneAlternative = $event)),
                                  style: {"display":"none"}
                                }, null, 512), [
                                  [_vModelText, _ctx.phoneAlternative],
                                  [_directive_mask, '(##) #####-####']
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_label, { position: "floating" }, {
                                  default: _withId(() => [
                                    _hoisted_14
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  modelValue: _ctx.email,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.email = $event)),
                                  type: "email",
                                  autocomplete: "email"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_row, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_button, {
                        shape: "round",
                        color: "primary",
                        expand: "full",
                        onClick: $options.editProfile
                      }, {
                        default: _withId(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})